module.exports = __webpack_public_path__ + "img/nayadetlopez.769cab72.jpg";